import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { LanguageProvider } from "./context/LanguageContext";
import { AuthProvider } from "./context/AuthContext";
import { UserProvider } from "./context/UserContext";
import { Navbar } from "./components/Navbar";
import { Footer } from "./components/Footer";
import { Home } from "./pages/Home";
import { Recipes } from "./pages/Recipes";
import { RecipeDetail } from "./pages/RecipeDetail";
import { Health } from "./pages/Health";
import { WhyVegan } from "./pages/WhyVegan";
import { Techniques } from "./pages/Techniques";
import { ShoppingList } from "./pages/ShoppingList";
import { MealPlanner } from "./pages/MealPlanner";
import { UserAuth } from "./pages/UserAuth";
import { ResetPassword } from "./pages/ResetPassword";
import { Favorites } from "./pages/Favorites";
import { AdminLogin } from "./pages/AdminLogin";
import { AdminDashboard } from "./pages/AdminDashboard";

function App() {
  return (
    <LanguageProvider>
      <AuthProvider>
        <UserProvider>
          <BrowserRouter>
            <div className="min-h-screen flex flex-col">
              <Navbar />
              <main className="flex-1">
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/recipes" element={<Recipes />} />
                  <Route path="/recipes/:id" element={<RecipeDetail />} />
                  <Route path="/health" element={<Health />} />
                  <Route path="/why-vegan" element={<WhyVegan />} />
                  <Route path="/techniques" element={<Techniques />} />
                  <Route path="/shopping-list" element={<ShoppingList />} />
                  <Route path="/meal-planner" element={<MealPlanner />} />
                  <Route path="/auth" element={<UserAuth />} />
                  <Route path="/reset-password" element={<ResetPassword />} />
                  <Route path="/favorites" element={<Favorites />} />
                  <Route path="/admin/login" element={<AdminLogin />} />
                  <Route path="/admin" element={<AdminDashboard />} />
                </Routes>
              </main>
              <Footer />
            </div>
            <Toaster position="top-right" />
          </BrowserRouter>
        </UserProvider>
      </AuthProvider>
    </LanguageProvider>
  );
}

export default App;
